import { createRouteRef } from '@backstage/core-plugin-api';

const rootRouteRef = createRouteRef({
  id: "vulnerabilities"
});
const vulnerabilityRouteRef = createRouteRef({
  id: "vulnerability",
  params: ["id"]
});

export { rootRouteRef, vulnerabilityRouteRef };
//# sourceMappingURL=routes.esm.js.map
